import { render, staticRenderFns } from "./OpportunitiesTable.vue?vue&type=template&id=7ddd43ca&scoped=true&"
import script from "./OpportunitiesTable.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd43ca",
  null
  
)

export default component.exports